module.exports = __webpack_public_path__ + "static/media/icon-mailchimp.1c03ad66.svg";